module.exports = __webpack_public_path__ + "full-screen-image-3.jpg";